const isValidDate = (date) => {
  return date instanceof Date && !isNaN(date.getTime());
};

export const formatDateStable = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  if (!isValidDate(d)) return '';
  
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${day}/${month}/${year}`;
};

export const formatTimeStable = (date) => {
  if (!date) return '';
  
  const d = new Date(date);
  if (!isValidDate(d)) return '';
  
  const hours = String(d.getHours()).padStart(2, '0');
  const minutes = String(d.getMinutes()).padStart(2, '0');
  const seconds = String(d.getSeconds()).padStart(2, '0');
  return `${hours}:${minutes}:${seconds}`;
};

